module.exports = __webpack_public_path__ + "img/tennisplatz.da729d55.jpg";